import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSocket } from '../../context/SocketContext'
import Loader from '../../compoment/ui/Loader';
import { clearTicketDetailFromStorage } from '../../utils/ticket';

const ReleaseScreen = () => {
    const texts = [
        { text: 'Now', className: 'animateTxtLg' },
        { text: 'Look at the wall', className: 'animateTxtLg' },
        { text: 'Stay where you are', className: 'animateTxtMd' },
        {
            text: 'You can control feather movement by moving your hand above the tablet',
            className: 'animateTxtSm',
        },
    ]

    const [loading, setLoading] = useState<boolean>(false);
    const [activeIndex, setActiveIndex] = useState(-1)
    const navigate = useNavigate()
    const location = useLocation() as { state?: { message?: string } }
    const { socket } = useSocket();
    const [, setLatestStatus] = useState('');

    // Emit status update when component mounts
    useEffect(() => {
        if (!socket || !location?.state?.message) return;

        const message = location.state.message;
        const statusUpdate = { status: 'in_use', message };
        console.log('Emitting updateReleaseRoomStatus:', statusUpdate);
        socket.emit('updateReleaseRoomStatus', statusUpdate);
        setLatestStatus(statusUpdate.status); // Update local state immediately
    }, [socket, location]);

    // Listen for status updates
    useEffect(() => {
        if (!socket) return;

        const handler = (update: any) => {
            console.log('Received releaseRoomStatusUpdate:', update);
            if (!update || typeof update.status !== 'string') return; // Ignore invalid updates

            setLatestStatus(update.status); // Update local state with latest status
            if (update.status === 'free') {
                setLoading(true);
                console.log('Status is free, scheduling navigation in 2.5s');
                setTimeout(() => {
                    // Only navigate if the latest status is still 'free'
                    setLatestStatus((currentStatus) => {
                        if (currentStatus === 'free') {
                            console.log('Navigating to /');
                            clearTicketDetailFromStorage();
                            navigate('/');
                        }
                        setLoading(false);
                        return currentStatus;
                    });
                }, 2500);
            }
        };

        socket.on('releaseRoomStatusUpdate', handler);
        return () => {
            socket.off('releaseRoomStatusUpdate', handler);
        };
    }, [socket, navigate]);


    useEffect(() => {
        // start after 1.5 sec
        const startTimeout = setTimeout(() => {
            setActiveIndex(0)

            const interval = setInterval(() => {
                setActiveIndex((prev) =>
                    prev + 1 < texts.length ? prev + 1 : prev // stop at last
                )
            }, 2000)

            return () => clearInterval(interval)
        }, 1500)

        return () => clearTimeout(startTimeout)
    }, [texts.length])

    useEffect(() => {
        if (activeIndex !== texts.length - 1) return

        const timeout = setTimeout(() => {
            clearTicketDetailFromStorage()
            navigate('/')
        }, 10000)

        return () => clearTimeout(timeout)
    }, [activeIndex, texts.length, navigate])



    return (
        <>
            {loading && <Loader />}
            <section className="mainSection portraitDevice">
                <div className="d-flex align-items-center justify-content-center h-100 flex-column text-center mx-auto" style={{ width: '90%' }}>
                    {texts.map((item, index) => (
                        <div
                            key={index}
                            className={`${item.className} animated-text ${index === activeIndex ? 'show' : 'hide'
                                }`}
                            dangerouslySetInnerHTML={{ __html: item.text }}
                        />
                    ))}
                </div>
            </section>
        </>
    )
}

export default ReleaseScreen
